@if (showIcon()) {
    <st-icon
        hasBorder
        [data]="data()"
        [type]="selectedValue()"
        [attr.medium]="mediumIcon()"
        [attr.disabled]="disabled()"
        [matMenuTriggerFor]="disabled() ? null : assignmentsMenu" />
}
@if (showLabel()) {
    <mat-chip
        st-assignment-icon
        addIcon="false"
        class="st-assignment-type__title"
        [data]="data()"
        [title]="selectedTypeLabel()"
        [itemType]="selectedValue()"
        [matMenuTriggerFor]="disabled() || showIcon() ? null : assignmentsMenu"
        [hasValue]="hasValue()">
        {{ selectedTypeLabel() }}
    </mat-chip>
}
<mat-menu
    #assignmentsMenu="matMenu"
    class="st-assignment-type-menu">
    @if (!disabled()) {
        <mat-selection-list
            multiple="false"
            [ngModel]="internalValue()">
            @for (item of assignmentTypes(); track item) {
                <mat-list-option
                    [value]="item?.id"
                    (click)="select(item.id)">
                    <st-icon
                        matListItemIcon
                        [type]="item.id" />
                    <div matListItemTitle>{{ item.title }}</div>
                </mat-list-option>
            }
        </mat-selection-list>
    }
</mat-menu>
